<div>
    <div
        class="card mb-3"
    >
        <div class="card-body">
            <h5 class="card-title">
                EMPLOYEE TAP CARDS
            </h5>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100">
                  <!-- Name Column -->
                  <ng-container matColumnDef="NAME">
                    <th mat-header-cell *matHeaderCellDef> NAME </th>
                    <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
                  </ng-container>

                  <!-- Title Column -->
                  <ng-container matColumnDef="TITLE">
                    <th mat-header-cell *matHeaderCellDef> TITLE </th>
                    <td mat-cell *matCellDef="let element"> {{ element.title }} </td>
                  </ng-container>

                  <!-- URL Column -->
                  <ng-container matColumnDef="TAPCARD URL">
                    <th mat-header-cell *matHeaderCellDef> TAPCARD URL </th>
                    <td mat-cell *matCellDef="let element">
                      <a *ngIf="element.url" [href]="element.url" target="_blank" (click)="$event.stopPropagation()">{{ element.url }}</a>
                      <span *ngIf="!element.url">—</span>
                    </td>
                  </ng-container>

                  <!-- CreatedAt Column -->
                  <ng-container matColumnDef="CREATED">
                    <th mat-header-cell *matHeaderCellDef> CREATED </th>
                    <td mat-cell *matCellDef="let element"> {{ element.createdAt | date:'short' }} </td>
                  </ng-container>

                  <!-- Interactions Column -->
                  <ng-container matColumnDef="INTERACTIONS">
                    <th mat-header-cell *matHeaderCellDef> INTERACTIONS </th>
                    <td mat-cell *matCellDef="let element"> {{ element.interactions }} </td>
                  </ng-container>

                  <!-- Mentions Column -->
                  <ng-container matColumnDef="MENTIONS">
                    <th mat-header-cell *matHeaderCellDef> MENTIONS </th>
                    <td mat-cell *matCellDef="let element"> {{ element.mentionCount }} </td>
                  </ng-container>

                    <!-- Mentions Column -->
                  <ng-container matColumnDef="LAST MONTH MENTIONS">
                    <th mat-header-cell *matHeaderCellDef> LAST MONTH MENTIONS </th>
                    <td mat-cell *matCellDef="let element"> {{ element.mentionCountLastMonth }} </td>
                  </ng-container>

                  <!-- Actions Column -->
                  <ng-container matColumnDef="ACTIONS">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> ACTIONS </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <button class="btn btn-borderless p-0 me-2" (click)="onEdit(element, $event)" title="Edit">
                        <icon-pencil></icon-pencil>
                      </button>
                      <button class="btn btn-borderless p-0" (click)="onDelete(element, $event)" title="Delete">
                        <icon-delete></icon-delete>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>  
</div>
<ngb-pagination *ngIf="((collectionSize) / pageSize) > 1"
  class="d-flex justify-content-center"
  style="max-width: 843px"
  [collectionSize]="collectionSize"
  [(page)]="page"
  [pageSize]="pageSize"
  [maxSize]="5"
  [rotate]="true"
  [ellipses]="true"
  [boundaryLinks]="true"
  (pageChange)="onPageChange(page)"
>
  <ng-template ngbPaginationNumber let-page>
    <div class="page">
      {{page}}
    </div>
  </ng-template>
  <ng-template ngbPaginationEllipsis>
    <div class="page">
      ...
    </div>
  </ng-template>
  <ng-template ngbPaginationFirst>
    <div class="page">
      ««
    </div>
  </ng-template>
  <ng-template ngbPaginationNext>
    <div class="page">
      »
    </div>
  </ng-template>
  <ng-template ngbPaginationPrevious>
    <div class="page">
      «
    </div>
  </ng-template>
  <ng-template ngbPaginationLast>
    <div class="page">
      »»
    </div>
  </ng-template>
</ngb-pagination>

